import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Gallery from "./pages/Gallery";
import Generate from "./pages/Generate";
import MemePage from "./pages/MemePage";
import AdminPanel from "./components/AdminPanel";
import { authService } from "./services/auth";

const PrivateRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  return authService.isAuthenticated() ? element : <Navigate to="/login" replace />;
};

const App: React.FC = () => {
  return (
    <Router>
      <nav className="app-nav">
        <a href="/" className="app-brand">🔐 MemeSec Factory</a>
        <div className="nav-items">
          <a href="/gallery">Gallery</a>
          <a href="/generate">Generate</a>
          {/* VULN: Admin link always visible — client-side guard only in AdminPanel */}
          <a href="/admin">Admin</a>
          {authService.isAuthenticated() ? (
            <button onClick={() => { authService.logout(); window.location.href = "/login"; }}>
              Logout
            </button>
          ) : (
            <a href="/login">Login</a>
          )}
        </div>
      </nav>

      <main className="app-main">
        <Routes>
          <Route path="/" element={<Navigate to="/gallery" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/memes/:id" element={<MemePage />} />
          <Route path="/generate" element={<PrivateRoute element={<Generate />} />} />
          {/* VULN: /admin accessible to any authenticated user — no server-side admin check */}
          <Route path="/admin" element={<PrivateRoute element={<AdminPanel />} />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
